import React from 'react';
import { ErrorLayoutContainer, ErrorScreenContainer, ErrorScreenImage, ErrorScreenLabel, ErrorScreenTitle, ErrorScreenActionContainer, ErrorScreenActionButton, ErrorScreenTertiaryButton, ErrorScreenSecondaryButton, } from './ErrorScreen.Styled';
import { FixedHeaderFooterLayout } from '../../layout';
export const ErrorScreen = ({ message, label, action, imgSrc = '', actionHandler, tertiaryAction, tertiaryHandler, secondaryAction, secondaryHandler, }) => {
    const hasFooter = action || secondaryAction || tertiaryAction;
    const mainContainerComponents = {
        body: (React.createElement(ErrorScreenContainer, null,
            React.createElement(ErrorScreenTitle, null, message),
            label && React.createElement(ErrorScreenLabel, null, label),
            React.createElement(ErrorScreenImage, { src: imgSrc, alt: "error-screen" }))),
        footer: (hasFooter &&
            React.createElement(ErrorScreenActionContainer, null,
                tertiaryAction && (React.createElement(ErrorScreenTertiaryButton, { onClick: tertiaryHandler }, tertiaryAction)),
                secondaryAction && (React.createElement(ErrorScreenSecondaryButton, { onClick: secondaryHandler }, secondaryAction)),
                action && (React.createElement(ErrorScreenActionButton, { onClick: actionHandler }, action))))
    };
    return (React.createElement(ErrorLayoutContainer, null,
        React.createElement(FixedHeaderFooterLayout, { bodyComponent: mainContainerComponents.body, footerComponent: mainContainerComponents.footer })));
};
//# sourceMappingURL=ErrorScreen.js.map